<section class="dashboard-container">
    @if(beginRender){
    @if(props?.title){
    <h6 class="header">{{props?.title}}</h6>
    }
    @for(elementInfo of gridSchema; track idx; let idx = $index){
    <section [ngClass]="['grid-container', elementInfo['inputs']?.containerClass ?? '']">
        @if(elementInfo['component']){
        <ng-container *ngComponentOutlet="elementInfo['component'],inputs:elementInfo['inputs']" />
        }
    </section>
    }
    @if(tabInfoText){
    <div class="tab-info-text">
        <span>
            <i class="fa-solid fa-circle-info tab-info-icon"></i>
            <span class="tab-info">{{ tabInfoText }}</span>
        </span>
    </div>
    }
    }
</section>